import { capture } from "./client";

/**
 * Typed wrappers for the 9 product-critical events. Call these directly
 * from feature code OR rely on the audit→PostHog bridge in `bridge.ts`,
 * which forwards the same event names automatically from `trackEvent()`.
 */
export const phEvents = {
  signup_started: (p: Record<string, unknown> = {}) => capture("signup_started", p),
  signup_completed: (p: Record<string, unknown> = {}) => capture("signup_completed", p),
  login_success: (p: Record<string, unknown> = {}) => capture("login_success", p),
  login_failed: (p: Record<string, unknown> = {}) => capture("login_failed", p),
  match_viewed: (p: Record<string, unknown> = {}) => capture("match_viewed", p),
  prediction_submitted: (p: Record<string, unknown> = {}) => capture("prediction_submitted", p),
  referral_created: (p: Record<string, unknown> = {}) => capture("referral_created", p),
  subscription_started: (p: Record<string, unknown> = {}) => capture("subscription_started", p),
  subscription_completed: (p: Record<string, unknown> = {}) => capture("subscription_completed", p),
} as const;

export type PostHogEventName = keyof typeof phEvents;

export const FORWARDED_EVENTS: ReadonlySet<string> = new Set<string>([
  "signup_started",
  "signup_completed",
  "login_success",
  "login_failed",
  "match_viewed",
  "prediction_submitted",
  "referral_created",
  "subscription_started",
  "subscription_completed",
]);